<template>
  <div class="addevent eventdata">
    <b-form @submit.prevent="onSubmit">
      <input type="hidden" name="client" v-model="client_name" />
      <input type="hidden" name="event_type" v-model="event_type" />

      <b-card no-body class="p-3">
        <template #header>
          <b-card-sub-title
            v-if="action == 'create'"
            class="my-0"
            v-bind:class="{
              'card-subtitle-doom-yoga': client_name == 'DY',
              'card-subtitle-irish-date': client_name == 'MID',
            }"
            >New {{ field_name }}</b-card-sub-title
          >
          <b-card-sub-title
            v-else-if="action == 'update'"
            class="my-0"
            v-bind:class="{
              'card-subtitle-doom-yoga': client_name == 'DY',
              'card-subtitle-irish-date': client_name == 'MID',
            }"
            >{{ field_name }} Info</b-card-sub-title
          >
        </template>

        <b-card-body class="pt-0">
          <EventBasicData
            :client_name="client_name"
            :field_name="field_name"
            :event_name.sync="event_name"
            :event_description.sync="event_description"
            :is_event_in_person.sync="is_event_in_person"
            :is_event_recurring.sync="is_event_recurring"
            :cover_image.sync="cover_image"
            :preview.sync="preview"
            :cover_image_id.sync="cover_image_id"
          />

          <EventDateTimeData
            :client_name="client_name"
            :field_name="field_name"
            :is_event_recurring="is_event_recurring"
            :recurrence.sync="recurrence"
            :repeat.sync="repeat"
            :multidate.sync="multidate"
            :invalid_occurs_on="invalid_occurs_on"
            :occurs_on.sync="occurs_on"
            :invalid_occurs_on_month="invalid_occurs_on_month"
            :occurs_on_month.sync="occurs_on_month"
            :invalid_start_date="invalid_start_date"
            :invalid_select_start_date="invalid_select_start_date"
            :event_start_date.sync="event_start_date"
            :invalid_end_date="invalid_end_date"
            :invalid_select_end_date="invalid_select_end_date"
            :event_end_date.sync="event_end_date"
            :event_date.sync="event_date"
            :invalid_date="invalid_date"
            :invalid_select_date="invalid_select_date"
            :from_time.sync="from_time"
            :to_time.sync="to_time"
            :invalid_time="invalid_time"
          />

          <!-- {{ recurrence }} -- {{ repeat }} -- {{ occurs_on }} --
          {{ occurs_on_month }}
          <br />
          {{ event_start_date }} -- {{ event_end_date }} <br />
          {{ from_time }} -- {{ to_time }} -->
          <EventOtherData
            :client_name="client_name"
            :field_name="field_name"
            :capacity_per_session.sync="capacity_per_session"
            :event_category.sync="event_category"
            :event_categories_list="event_categories_list"
            :invalid_event_category="invalid_event_category"
          />
        </b-card-body>
      </b-card>
      <event-payment
        :price_per_session.sync="price_per_session"
        :amount.sync="amount"
        :invalid_session_price="invalid_session_price"
        :client_name="client_name"
      />
      <event-location
        :location.sync="location"
        :address.sync="address"
        :address_coordinates.sync="address_coordinates"
        :invalid_location="invalid_location"
        :invalid_address="invalid_address"
        :client_name="client_name"
        :locations="locations"
      />
      <b-row>
        <b-col lg="3" offset-lg="9" md="4" offset-md="8" sm="6" offset-sm="6">
          <b-button
            type="submit"
            :variant="client_name == 'DY' ? 'doomyoga-primary' : 'mid-primary'"
            class="w-100"
            v-bind:class="{
              'btn-bumblebee btn-doomyoga btn-doom-yoga-submit':
                client_name == 'DY',
              'btn-bumblebee btn-mid btn-mid-submit': client_name == 'MID',
            }"
            v-if="!is_loading"
          >
            {{ action }} {{ field_name }}
          </b-button>
          <b-button
            type="button"
            disabled
            :variant="client_name == 'DY' ? 'doomyoga-primary' : 'mid-primary'"
            class="w-100"
            v-bind:class="{
              'btn-bumblebee btn-doomyoga btn-doom-yoga-submit':
                client_name == 'DY',
              'btn-bumblebee btn-mid btn-mid-submit': client_name == 'MID',
            }"
            v-else
          >
            <b-spinner small label="Small Spinner" variant="light"></b-spinner>
            Loading
          </b-button>
        </b-col></b-row
      >
    </b-form>
  </div>
</template>

<script>
import mDatePicker from "@/components/multi-date-picker/multiDatePicker.vue";
import $, { event } from "jquery";
import axios from "axios";
import moment from "moment";
import EventBasicData from "./BasicData.vue";
import EventDateTimeData from "./DateTimeData.vue";
import EventOtherData from "./OtherData.vue";
import EventPayment from "./Payment.vue";
import EventLocation from "./Location.vue";

export default {
  name: "EventInfo",
  props: [
    "client_name",
    "field_name",
    "event_type",
    "currency",
    "locations",
    "action",
  ],
  components: {
    mDatePicker,
    EventBasicData,
    EventDateTimeData,
    EventOtherData,
    EventPayment,
    EventLocation,
  },
  data() {
    return {
      event_id: null,
      is_loading: false,

      event_name: null,
      event_description: null,
      is_event_in_person: "",
      cover_image: null,
      preview: null,
      cover_image_id: null,

      capacity_per_session: null,
      event_category: null,
      event_categories_list: [],
      invalid_event_category: false,

      location: "",
      invalid_location: false,
      address: "",
      address_coordinates: null,
      invalid_address: false,
      price_per_session: "",
      amount: "",
      invalid_session_price: false,

      is_event_recurring: "",
      recurrence: null,
      repeat: null,
      invalid_occurs_on: false,
      occurs_on: [],
      invalid_occurs_on_month: false,
      occurs_on_month: null,

      event_date: null,
      multidate: false,
      invalid_date: false,
      invalid_select_date: false,
      event_start_date: null,
      invalid_start_date: false,
      invalid_select_start_date: false,
      event_end_date: null,
      invalid_end_date: false,
      invalid_select_end_date: false,

      from_time: "",
      to_time: "",
      invalid_time: false,

      swal_confirm_button_class: "",
      swal_container_class: "",
    };
  },

  watch: {
    cover_image: function (val) {
      console.log("in watch cover image");
      console.log(val);
    },
    event_date: function (val) {
      console.log(val);
      let current_date = this.getCurrentDateOnly();

      if (
        this.event_date == null ||
        this.event_date == "" ||
        (Array.isArray(this.event_date) && this.event_date.length == 0)
      ) {
      } else {
        if (this.multidate == false) {
          var diff = new Date(val).getTime() - current_date;
          if (diff < 0) {
            this.invalid_select_date = true;
          } else {
            this.invalid_select_date = false;
          }
        } else {
          for (var i = 0; i < this.event_date.length; i++) {
            var diff = new Date(this.event_date[i]).getTime() - current_date;
            if (diff < 0) {
              this.invalid_select_date = true;
              break;
            }
            if (i == this.event_date.length - 1) {
              this.invalid_select_date = false;
            }
          }
        }
      }
    },
    event_start_date: function (val) {
      console.log(val);
      let current_date = this.getCurrentDateOnly();

      if (this.event_start_date != null && this.event_start_date != "") {
        var diff = new Date(val).getTime() - current_date;
        if (diff < 0) {
          this.invalid_select_start_date = true;
        } else {
          this.invalid_select_start_date = false;
        }
      }
    },
    event_end_date: function (val) {
      console.log(val);

      if (
        (this.event_start_date != null &&
          this.event_start_date != "" &&
          this.event_end_date != null) ||
        this.event_end_date != ""
      ) {
        var diff =
          new Date(this.event_end_date).getTime() -
          new Date(this.event_start_date).getTime();
        if (diff <= 0) {
          this.invalid_select_end_date = true;
        } else {
          this.invalid_select_end_date = false;
        }
      }
    },
  },
  mounted() {
    // console.log(JSON.parse(window.localStorage.getItem("user")));
    // console.log(this.client_name);
    if (this.client_name == "DY") {
      this.swal_confirm_button_class =
        "btn btn-bumblebee btn-doomyoga  btn-doomyoga-primary";
      this.swal_container_class = "swal-container-dy";
    }

    if (this.client_name === "MID") {
      this.getEventCategories();
    }

    if (this.action === "update") {
      axios
        .get("event/events/" + this.$route.params.id, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            client: this.client_name,
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then((response) => {
          console.log(response);
          // this.events = response.data;
          this.setEventData(response.data);
        });

      console.log("update event id " + this.$route.params.id);
      this.event_id = this.$route.params.id;
    }
  },
  created() {},
  methods: {
    getEventCategories() {
      axios
        .get("event/event-categories", {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            client: this.client_name,
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then((response) => {
          console.log(response);
          console.log(response.data);
          this.event_categories_list = response.data;
          // this.events = response.data;
          // this.setEventData(response.data);
        });
    },
    setEventData(event) {
      console.log("in set event data ");
      console.log(event);
      this.event_name = event.name;
      this.event_description = event.description;
      this.event_type = event.type;
      this.$emit("update:event_type", event.type);
      this.preview = event.cover.path;

      this.from_time = event.from;
      this.to_time = event.to;
      this.capacity_per_session = event.capacity;

      this.price_per_session = event.price_type;
      if (event.price_type === "fixed") {
        this.amount = event.price;
      }

      if (event.location_type === "on_site") {
        this.location = event.location_type;
        this.address = event.address;
        this.address_coordinates = event.location;
      } else if (event.location_type === "online") {
        this.location = event.address;
      }

      this.is_event_in_person = event.is_person;
      this.is_event_recurring = event.is_recurring;
      // this.multidate = this.is_event_recurring == 1;

      // setTimeout(function () {
      console.log(this.event_date);
      if (this.is_event_recurring == 0) {
        this.event_date = new Date(event.dates[0]);
        this.event_date.setHours(0);
        this.event_date.setMinutes(0);
        this.event_date.setSeconds(0);
        this.event_date.setMilliseconds(0);
        this.multidate = false;
        //  if (event.recurrence == null) {
        //   this.recurrence = "";
        // }
      } else {
        if (event.dates != null) {
          this.multidate = true;
          console.log(event.dates);
          let dates = [];
          event.dates.forEach((item) => {
            console.log(item);
            let datetemp = new Date(item);
            datetemp.setHours(0);
            datetemp.setMinutes(0);
            datetemp.setSeconds(0);
            datetemp.setMilliseconds(0);
            dates.push(datetemp);
          });
          console.log(dates);
          this.event_date = dates;
        }
        if (event.start_date != null) {
          this.multidate = false;
          console.log(new Date());
          console.log(moment(event.start_date, "DD-MM-yyyy").toDate());
          console.log(moment(event.end_date, "DD-MM-yyyy").toDate());
          this.event_start_date = moment(
            event.start_date,
            "DD-MM-yyyy"
          ).toDate();
          this.event_end_date = moment(event.end_date, "DD-MM-yyyy").toDate();
        }
        this.recurrence = event.recurrence;
        if (event.recurrence == null) {
          this.recurrence = "";
        }
        if (event.recurrence != "no_fixed_time") {
          this.repeat = event.repeat_every;
          if (event.recurrence == "week") {
            this.occurs_on = event.week_days;
          }
          if (event.recurrence == "month") {
            this.occurs_on_month = event.month_days[0];
          }
        }
      }
      console.log(this.event_date);

      this.event_category = event.category.id;
    },
    clickIsRecuring(val) {
      console.log("curr ", val);
      if (val === 0) {
        this.event_date = null;
        this.multidate = false;
        this.recurrence = "";
        this.repeat = null;
      } else {
        this.event_date = null;
        this.multidate = false;
        this.recurrence = "day";
        this.repeat = 1;
      }
    },
    checkValidation() {
      console.log("--------- in check validation -----");
      this.invalid_date = false;
      this.invalid_time = false;
      this.invalid_session_price = false;
      this.invalid_location = false;
      this.invalid_address = false;
      this.invalid_event_category = false;
      this.invalid_start_date = false;
      this.invalid_end_date = false;
      this.invalid_occurs_on = false;
      this.invalid_occurs_on_month = false;
      this.invalid_select_date = false;
      this.invalid_select_start_date = false;
      this.invalid_select_end_date = false;

      if (
        this.from_time == null ||
        this.from_time == "" ||
        this.to_time == null ||
        this.to_time == ""
      ) {
        this.invalid_time = true;
      } else {
        this.invalid_time = false;
      }
      if (this.price_per_session == "" || this.price_per_session == null) {
        this.invalid_session_price = true;
      } else {
        this.invalid_session_price = false;
      }
      if (this.location == "" || this.location == null) {
        this.invalid_location = true;
      } else {
        this.invalid_location = false;
      }
      if (
        this.location === "on_site" &&
        (this.address == "" ||
          this.address == null ||
          this.address_coordinates == "" ||
          this.address_coordinates == null)
      ) {
        this.invalid_address = true;
      } else {
        this.invalid_address = false;
      }
      if (
        this.client_name == "MID" &&
        (this.event_category == "" || this.event_category == null)
      ) {
        this.invalid_event_category = true;
      } else {
        this.invalid_event_category = false;
      }
      if (
        this.is_event_recurring == 0 ||
        (this.is_event_recurring == 1 && this.recurrence == "no_fixed_time")
      ) {
        if (
          this.event_date == null ||
          this.event_date == "" ||
          (Array.isArray(this.event_date) && this.event_date.length == 0)
        ) {
          this.invalid_date = true;
        } else {
          this.invalid_date = false;
          if (this.action == "create") {
            let current_date = this.getCurrentDateOnly();

            if (this.multidate == false) {
              var diff = new Date(this.event_date).getTime() - current_date;
              if (diff < 0) {
                this.invalid_select_date = true;
              } else {
                this.invalid_select_date = false;
              }
            } else {
              for (var i = 0; i < this.event_date.length; i++) {
                var diff =
                  new Date(this.event_date[i]).getTime() - current_date;
                if (diff < 0) {
                  this.invalid_select_date = true;
                  break;
                }
                if (i == this.event_date.length - 1) {
                  this.invalid_select_date = false;
                }
              }
            }
          }
        }
      } else if (
        this.is_event_recurring == 1 &&
        this.recurrence != "no_fixed_time"
      ) {
        if (this.event_start_date == null || this.event_start_date == "") {
          this.invalid_start_date = true;
        } else {
          this.invalid_start_date = false;
          if (this.action == "create") {
            let current_date = this.getCurrentDateOnly();

            var diff = new Date(this.event_start_date).getTime() - current_date;
            if (diff < 0) {
              this.invalid_select_start_date = true;
            } else {
              this.invalid_select_start_date = false;
              if (
                (this.event_start_date != null &&
                  this.event_start_date != "" &&
                  this.event_end_date != null) ||
                this.event_end_date != ""
              ) {
                var diff =
                  new Date(this.event_end_date).getTime() -
                  new Date(this.event_start_date).getTime();
                if (diff <= 0) {
                  this.invalid_select_end_date = true;
                } else {
                  this.invalid_select_end_date = false;
                }
              }
            }
          }
        }
        if (this.event_end_date == null || this.event_end_date == "") {
          this.invalid_end_date = true;
        } else {
          this.invalid_end_date = false;
        }
        if (this.recurrence == "month") {
          if (this.occurs_on_month == null || this.occurs_on_month == "") {
            this.invalid_occurs_on_month = true;
          } else {
            this.invalid_occurs_on_month = false;
          }
        } else if (this.recurrence == "week") {
          if (
            this.occurs_on.length == 0 ||
            this.occurs_on == null ||
            this.occurs_on == ""
          ) {
            this.invalid_occurs_on = true;
          } else {
            this.invalid_occurs_on = false;
          }
        }
      }
    },
    onSubmit(event) {
      console.log(event);
      console.log(this.event_category);
      console.log(this.cover_image);
      // console.log(this.preview);

      this.is_loading = true;

      console.log(this.action);
      console.log(this.client_name);
      console.log(this.event_type);

      console.log(this.event_name);
      console.log(this.event_description);
      console.log(this.is_event_in_person);
      console.log(this.capacity_per_session);
      console.log(this.price_per_session);
      console.log(this.amount);
      console.log(this.location);
      console.log(this.address);
      console.log(this.address_coordinates);
      console.log(this.cover_image_id);
      console.log(this.event_category);

      console.log(this.from_time);
      console.log(this.to_time);

      console.log(this.is_event_recurring);
      console.log("recurrence ", this.recurrence);
      console.log("repeat ", this.repeat);
      console.log(this.event_date);
      console.log(this.event_start_date);
      console.log(this.event_end_date);
      console.log(this.multidate);
      console.log("occurs on ", this.occurs_on);
      console.log("occues on month", this.occurs_on_month);

      // return;
      this.checkValidation();
      console.log("after validation", this.action);
      console.log("date ", this.invalid_date);
      console.log("time ", this.invalid_time);
      console.log("session price ", this.invalid_session_price);
      console.log("location ", this.invalid_location);
      console.log("address ", this.invalid_address);
      console.log("category ", this.invalid_event_category);
      console.log(
        "start , end date ",
        this.invalid_start_date,
        this.invalid_end_date
      );
      console.log("occurs on  ", this.invalid_occurs_on);
      console.log("occurs on month ", this.invalid_occurs_on_month);
      console.log("select date ", this.invalid_select_date);
      console.log("select start date ", this.invalid_select_start_date);
      console.log("select end date ", this.invalid_select_end_date);

      if (
        (!this.invalid_date &&
          !this.invalid_time &&
          !this.invalid_session_price &&
          !this.invalid_location &&
          !this.invalid_address &&
          !this.invalid_event_category &&
          !this.invalid_start_date &&
          !this.invalid_end_date &&
          !this.invalid_occurs_on &&
          !this.invalid_occurs_on_month &&
          this.action == "update" &&
          !this.invalid_select_end_date) ||
        (!this.invalid_date &&
          !this.invalid_time &&
          !this.invalid_session_price &&
          !this.invalid_location &&
          !this.invalid_address &&
          !this.invalid_event_category &&
          !this.invalid_start_date &&
          !this.invalid_end_date &&
          !this.invalid_occurs_on &&
          !this.invalid_occurs_on_month &&
          this.action == "create" &&
          !this.invalid_select_date &&
          !this.invalid_select_start_date &&
          !this.invalid_select_end_date)
      ) {
        if (this.cover_image != null && this.preview != null) {
          console.log("send img request");

          let formData = new FormData();
          formData.append("client", this.client_name);
          formData.append("selectedfile", this.cover_image);

          axios
            .post("filesmodule/upload", formData, {
              headers: {
                Accept: "application/json",
                "Content-Type": "multipart/form-data",
                Authorization:
                  "Bearer " +
                  JSON.parse(window.localStorage.getItem("user")).access_token,
              },
            })
            .then((response) => {
              console.log(response);
              //this.is_loading = false;
              this.cover_image_id = response.data.id;
              this.getEventDataToSend();
            })
            .catch((error) => {
              console.log(error);
              this.$fire({
                // title: "Title",
                text: error,
                type: "error",
                timer: 5000,
                customClass: {
                  container: this.swal_container_class,
                  confirmButton: this.swal_confirm_button_class,
                },
              }).then((r) => {
                // console.log(r.value);
              });
            });
        } else {
          this.getEventDataToSend();
        }
      } else {
        this.is_loading = false;
      }

      // var temp = this;
      // setTimeout(function () {
      //   temp.is_loading = false;
      // }, 1000);
    },
    getEventDataToSend() {
      // send request

      console.log("validated ");
      console.log(this.client_name);
      let formData = new FormData();
      formData.append(
        "organizer_id",
        JSON.parse(window.localStorage.getItem("user")).id
      );
      formData.append("client", this.client_name);
      formData.append("type", this.event_type);
      formData.append("name", this.event_name);
      if (this.event_description != null) {
        formData.append("description", this.event_description);
      }
      if (this.cover_image_id != null) {
        formData.append("cover", this.cover_image_id);
      }
      formData.append("is_person", this.is_event_in_person);
      formData.append("capacity", this.capacity_per_session);
      formData.append("price_type", this.price_per_session);
      formData.append("price", this.amount);

      if (this.location === "on_site") {
        formData.append("location_type", "on_site");
        formData.append("address", this.address);
        formData.append("location", JSON.stringify(this.address_coordinates));
      } else {
        formData.append("location_type", "online");
        formData.append("address", this.location);
      }

      formData.append("is_recurring", this.is_event_recurring);
      formData.append(
        "from",
        moment(this.from_time, "HH:mm:ss").format("HH:mm")
      );
      formData.append("to", moment(this.to_time, "HH:mm:ss").format("HH:mm"));

      if (this.is_event_recurring == 0) {
        formData.append(
          "dates[]",
          moment(this.event_date).format("yyyy-MM-DD")
        );
      } else if (this.is_event_recurring == 1) {
        formData.append("recurrence", this.recurrence);
        if (this.recurrence == "no_fixed_time") {
          this.event_date.forEach((item) => {
            formData.append("dates[]", moment(item).format("yyyy-MM-DD"));
          });
        } else {
          formData.append("repeat_every", this.repeat);
          formData.append(
            "start_date",
            moment(this.event_start_date).format("DD-MM-yyyy")
          );
          formData.append(
            "end_date",
            moment(this.event_end_date).format("DD-MM-yyyy")
          );

          if (this.recurrence == "month") {
            formData.append("month_days[]", this.occurs_on_month);
          } else if (this.recurrence == "week") {
            //  formData.append("week_days[]", this.occurs_on);
            this.occurs_on.forEach((item) => {
              formData.append("week_days[]", item);
            });
          }
        }
      }
      if (this.client_name == "MID" || this.event_category != null) {
        formData.append("category_id", this.event_category);
      }

      console.log(formData);
      console.log(formData.get("name"));
      console.log(formData.get("organizer_id"));

      if (this.action === "create") {
        this.sendCreateRequest(formData);
      } else if (this.action === "update") {
        this.sendUpdateRequest(formData);
      }
    },
    sendCreateRequest(formData) {
      axios
        .post("event/events", formData, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then((response) => {
          console.log(response);
          this.$fire({
            // title: "Title",
            text: this.field_name + " is created successfully",
            type: "success",
            // timer: 3000,
            customClass: {
              container: this.swal_container_class,
              confirmButton: this.swal_confirm_button_class,
            },
          }).then((r) => {
            // console.log(r.value);
            this.is_loading = false;
            this.$router.go();
          });
        })
        .catch((error) => {
          console.log(error.response);
          this.is_loading = false;
          this.$fire({
            // title: "Title",
            text: error.response.data.error,
            type: "error",
            // timer: 3000,
            customClass: {
              container: this.swal_container_class,
              confirmButton: this.swal_confirm_button_class,
            },
          }).then((r) => {
            // console.log(r.value);
            this.is_loading = false;
          });
        });
    },
    sendUpdateRequest(formData) {
      console.log("in send update request " + this.event_id);
      console.log(formData.get("name"));
      formData.append("id", this.event_id);
      console.log(formData.get("id"));
      console.log(this.client_name);
      formData.append("_method", "put");

      axios
        .post("event/events/" + this.event_id, formData, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/x-www-form-urlencoded",
            client: this.client_name,
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then((response) => {
          console.log(response);
          this.$fire({
            // title: "Title",
            text: this.field_name + " is updated successfully",
            type: "success",
            timer: 3000,
            customClass: {
              container: this.swal_container_class,
              confirmButton: this.swal_confirm_button_class,
            },
          }).then((r) => {
            // console.log(r.value);
            this.is_loading = false;
            this.$router.go();
          });
        })
        .catch((error) => {
          console.log(error.response);
          this.is_loading = false;
          this.$fire({
            // title: "Title",
            text: error.response.data.error,
            type: "error",
            // timer: 3000,
            customClass: {
              container: this.swal_container_class,
              confirmButton: this.swal_confirm_button_class,
            },
          }).then((r) => {
            // console.log(r.value);
            this.is_loading = false;
          });
        });
    },

    // helper fun
    getCurrentDateOnly() {
      let current_date = new Date();
      current_date.setHours(0);
      current_date.setMinutes(0);
      current_date.setSeconds(0);
      current_date.setMilliseconds(0);
      console.log(current_date);
      current_date = current_date.getTime();
      console.log(current_date);
      return current_date;
    },
  },
};
</script>

<style >
.imgFromGroup > div {
  height: calc(100% - 35px);
  max-height: calc(100% - 35px);
}
</style>


// WEBPACK FOOTER //
// src/components/events/EventInfo.vue